function resolveCompositeProductId() {
    const rootAttr = root.getAttribute('data-product-id');
    if (rootAttr && /^\d+$/.test(rootAttr)) return Number(rootAttr);
    if (window.WCCP_DATA && window.WCCP_DATA.product_id) return Number(window.WCCP_DATA.product_id);
    const m = location.pathname.match(/product\/(\d+)/);
    if (m) return Number(m[1]);
    return 0;
}